var app = app || {};
(function ($) {
  $(document).ready(
    function () {
      app.menu.init();

    }
  );

  app.menu = new function () {

    this.init = function () {
      app.menu.initScroll();
      app.menu.initMenu();
      app.menu.initHamburger();
      app.menu.initFooterForms();
      app.menu.initScrollToHash();


      $(document).on('app:escape', function () {
        app.menu.closeMenu();
      });
    };


    this.initScrollToHash = function () {

      if (window.location.hash == '#filter') {
        var $filter = $('a[name="filter"');
        if ($filter.length) {
          $('html,body').scrollTop($filter.offset().top)
        }
      }
      setTimeout(() => {
        if (window.location.hash == '#filter') {
          var $filter = $('a[name="filter"');
          if ($filter.length) {
            $('html,body').scrollTop($filter.offset().top)
          }
        }
      }, 100);
    };
    this.initFooterForms = function () {
      var locationStr = window.location.toString();
      if (locationStr.includes('form_type=customer') || locationStr.includes('customer_posted=true')) {
        window.location.hash = 'ContactFooter';
      }
      else if (locationStr.includes('form_type=contact') || locationStr.includes('contact_posted=true')) {
        if ($('#ContactFormFooter').length) {
          window.location.hash = 'ContactFormFooter';
        }
        else if ($('#ContactForm').length) {
          window.location.hash = 'ContactForm';
        }

      }
      $('#ContactFooter input').on('focus', function () {
        if (window.location.hash != "ContactFooter") {
          history.pushState({}, "", "#ContactFooter")
        }
      });

      $('#ContactFormFooter input').on('focus', function () {
        if (window.location.hash != "ContactFormFooter") {
          history.pushState({}, "", "#ContactFormFooter")
        }
      });

      $('#ContactForm input').on('focus', function () {
        if (window.location.hash != "ContactForm") {
          history.pushState({}, "", "#ContactForm")
        }
      });
    };
    this.initScroll = function () {
      $(window).on('scroll.initScroll', function () {
        var top = parseInt($(window).scrollTop());
        if (top > 10) {
          $('body').addClass('scrolled home-splashed');
          $('.nav').removeClass('nav--transparent');
        }
        else {
          $('body').removeClass('scrolled');
        }
      });
    };
    this.initHamburger = function () {
      if (!app.main.isDesktop()) {
        $('.nav__hamburger').attr('aria-hidden', 'false');
      }
      $('.js-hamburger').on('click', function () {
        if ($(this).attr('aria-expanded') == 'true') {
          app.menu.closeMenu();
        }
        else {
          app.menu.openMenu();
        }


        app.aria.tabIndex.enableVisible($('body'));
      });

      app.aria.tabIndex.enableVisible($('body'));

    };






    this.initMenu = function () {
      $('.js-menu-open').on('click', function () {
        app.menu.openMenu();

      });
      $('.js-menu-close').on('click', function () {
        app.menu.closeMenu();
      });

      $('.nav__menu a').on('click', function () {
        app.menu.closeMenu();
      });

      $('.js-submenu-toggle').on('click', function (e) {
        e.preventDefault();
        if ($(this).attr('aria-expanded') == 'true') {
          app.menu.closeSubMenu($(this).parent());
        }
        else {
          app.menu.openSubmenu($(this).parent());
        }
        return false;

      });


    };


    this.openMenu = function () {
      $('body').addClass('menu-open');
      $('.nav__hamburger').attr('aria-expanded', 'true');
      $('.searchmenu').attr('open', 'true');
      $('.nav__menu').attr('aria-hidden', 'false');
      $('body').addClass('home-splashed');
      app.aria.tabIndex.disableAll($('body'));
      app.aria.tabIndex.enableVisible($('.banner'));
    };

    this.closeMenu = function () {
      $('body').removeClass('menu-open');
      $('.nav__menu').attr('aria-hidden', 'true');
      $('.nav__hamburger').attr('aria-expanded', 'false');
      $('.searchmenu').removeAttr('open');
      app.aria.tabIndex.enableVisible($('body'));
    };





  };




})(jQuery);
